import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Output,
} from "@angular/core";
import {
  PodInfo,
  PodInfoService,
} from "../../../../core/services/pod-info.service";
import { NodeService } from "../../../../core/services/node.service";
import { filter, interval, lastValueFrom, Subject, Subscription, takeUntil } from "rxjs";
import {
  ContainerPort,
  ContainerStatus,
  ContainerStatusUI,
  PodDetailsDTO,
  Resources,
  VolumeMount,
} from "../../../../core/models/podAdditionalInfo";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { NodeAction } from "../../../../core/models/node";
import { SyncConfigService } from "src/app/core/services/sync-config.service";
import { StorageService } from "src/app/core/services/storage.service";
import { NavigationService } from "src/app/core/services/navigation.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { EnvironmentService } from "src/app/core/services/environment.service";
import { MatDialog } from "@angular/material/dialog";
import { TerminalComponent } from "src/app/core/header/dialogs/terminal/terminal.component";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-pod-advance-view",
  templateUrl: "./pod-advance-view.component.html",
  styleUrl: "./pod-advance-view.component.scss",
})
export class PodAdvanceViewComponent {
  private nodeService = inject(NodeService);
  private podService = inject(PodInfoService);
  private cdRef = inject(ChangeDetectorRef);
  private spinner = inject(NgxSpinnerService);
  private router = inject(Router);
  private syncConfig = inject(SyncConfigService);
  private storageService = inject(StorageService);
  private sharedService = inject(NavigationService);
  private _deploymentService = inject(DeploymentService);
  private _env = inject(EnvironmentService);
  public dialog = inject(MatDialog);
  private snackBar = inject(MatSnackBar);
  @Output() hideDetails = new EventEmitter();
  @Output() actionPerform = new EventEmitter();
  selectedPod: PodInfo = this.nodeService.activePod;
  destroy$ = new Subject<void>();
  podDetails: PodDetailsDTO;
  actionList: string[] = ["Delete", "Update"];
  currentActiveIndex: Number = 0;
  numOfContainers: any;
  runningContainers: any;
  terminatedConatiners: any;
  waitingContainers: any;
  containerListUI: ContainerStatusUI[] = [];
  containerList: ContainerStatus[] = [];
  depName: string;
  podDetailsAutoReloadSub: Subscription;
  podActions: NodeAction[] = [
    {
      name: "Delete",
      value: 11,
      title: "Delete Pod",
      icon: "bi bi-x-lg",
      disabled: true,
    }
  ];

  ngOnInit(): void {
    this.loadPodDetails();
    this.podDetailsAutoReloadSub = interval(
      this.syncConfig.config.jobs.detailsReqInterval
    ).subscribe((x) => {
      this.loadPodDetails();
    });
  }

  returnActionsAvailableForPod() {
    let actions: NodeAction[] = [...this.podActions];
    actions.find((act) => act.value == 11).disabled = false;
    return actions;
  }
  loadPodDetails() {
    this.spinner.show("podSpinner");
    this.nodeService.SelectedPod.pipe(
      takeUntil(this.destroy$),
      filter((x) => x != null)
    ).subscribe((data) => {
      this.selectedPod = this.nodeService.activePod;
      this.depName = this.selectedPod.deploymentName;
      this.podService
        .getSpecificPodInfo(
          this.selectedPod.deploymentName,
          this.selectedPod.podName
        )
        .subscribe({
          next: (res) => {
            this.spinner.hide("podSpinner");
            this.podDetails = <PodDetailsDTO>JSON.parse(JSON.stringify(res));
            this.getConatinerInfo();
          },
          error: (err) => {
            this.spinner.hide("podSpinner");
            this.podDetails = null;
          },
        });
    });
  }

  refreshComponent() {
    this.loadPodDetails();
  }

  redirectTo() {
    let jobName = this.getJobName();
    if (jobName) {
      let url = `/Jobs List/On-Premise/${this.depName}/Jobs/${jobName}/jobDetails/pod`;
      this.router.navigate([
        `/Jobs List/On-Premise/${this.depName}/Jobs/${jobName}/jobDetails/pod`,
      ]);
    }
  }

  getJobName() {
    let jobName = this.podDetails.metadata?.ownerReferences.find(
      (o) => o.kind == "Job"
    );
    if (jobName) {
      return jobName.name;
    }
    return null;
  }

  getConatinerInfo() {
    this.numOfContainers = this.podDetails?.status?.containerStatuses?.length;
    let containerStatusList: ContainerStatus[] =
      this.podDetails?.status?.containerStatuses;
    this.containerList = this.podDetails?.status?.containerStatuses;
    if (this.containerList && this.containerList.length > 0) {
      this.containerListUI = [];
      this.containerList.forEach(container => {
        let resourceList: Resources[] = this.podDetails?.spec?.containers.filter(c => c.name == container.name).map(c => c.resources);
        let volumeMounts: VolumeMount[] = this.podDetails?.spec?.containers.filter(c => c.name == container.name && c.volumeMounts).flatMap(c => c.volumeMounts);
        //let ports: ContainerPort[] = this.podDetails?.spec?.containers.filter(c => c.ports).flatMap(c => c.ports);
        this.containerListUI.push({
          containerID: container.containerID,
          name: container.name,
          image: container.image,
          ready: container.ready,
          started: container.started,
          imageID: container.imageID,
          state: container.state,
          restartCount: container.restartCount,
          Resources: resourceList && resourceList.length > 0 ? resourceList[0] : null,
          VolumeMounts: volumeMounts && volumeMounts.length > 0 ? volumeMounts : null,
          // Ports: ports && ports.length > 0 ? ports : null
          Ports: null
        });
      });
    }
    if (containerStatusList != null && containerStatusList.length != 0) {
      let runningContainers = 0;
      let terminatedContainers = 0;
      let waitingContainers = 0;
      containerStatusList.forEach((c) => {
        if (c.state.running?.startedAt != null) {
          runningContainers += 1;
        }
        if (c.state.terminated?.startedAt != null) {
          terminatedContainers += 1;
        }
        if (c.state.waiting?.startedAt != null) {
          waitingContainers += 1;
        }
      });
      this.runningContainers = runningContainers;
      this.terminatedConatiners = terminatedContainers;
      this.waitingContainers = waitingContainers;
    }
  }

  close() {
    this.nodeService.updateSelectedPod(null);
    this.hideDetails.emit("true");
  }

  emitPodAction(action) {
    let res = { "action": action, "podInfo": this.selectedPod };
    this.actionPerform.emit(res);
  }

  ngOnDestroy(): void {
    if (this.podDetailsAutoReloadSub) {
      this.podDetailsAutoReloadSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  focusOnTab(index: Number) {
    this.currentActiveIndex = index;
    this.cdRef.detectChanges();
  }

  async runCommand() {
    const headNodeIp: any = await lastValueFrom(
      this.storageService.getHeadNodeIp(this.depName)
    );
    fetch('https://' + headNodeIp.vmIp + ':' + this._env.envVariables.UtilityAccessPort + "/health", { mode: 'no-cors' })
      .then(() => {
        this.sharedService.closeOpenedDialogs();
        this.dialog.open(TerminalComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: "custom-terminal-container",
          hasBackdrop: false,
          id: "terminalDialog",
          data: {
            username: '',
            password: '',
            serverAddress: this._deploymentService.getUrlForUtilityService(
              this.depName,
              headNodeIp.vmIp,
              '5001',
              4,
              true
            ),
            reqFromPod: true,
            namespace: this.selectedPod.namespace,
            podName: this.selectedPod.podName,
            headNodeIp: headNodeIp.vmIp,
          },
        });
      })
      .catch((err) => {
        this.snackBar.open("Please check and accept pod manager status", "OK", {}).afterDismissed().subscribe(() => {
          window.open('https://' + headNodeIp.vmIp + ':' + this._env.envVariables.UtilityAccessPort + "/health", '_blank');
        });
        return;
      });
  }
}
